export const th = {
    default: {
        search: 'ค้นหา',
        confirm: 'ยืนยัน',
    },
    date: {
        days: 'วัน',
        months: 'เดือน',
        years: 'ปี',
        minutes: 'นาที',
        minutes_short: 'น.',
        hours: 'ชั่วโมง',
        hours_short: 'ช.ม.',
        date_flase: 'กรุณาระบุวันเกิด',
        month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
        month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
        { strvalue: '02', strtext: 'กุมภาพันธ์' },
        { strvalue: '03', strtext: 'มีนาคม' },
        { strvalue: '04', strtext: 'เมษายน' },
        { strvalue: '05', strtext: 'พฤษภาคม' },
        { strvalue: '06', strtext: 'มิถุนายน' },
        { strvalue: '07', strtext: 'กรกฎาคม' },
        { strvalue: '08', strtext: 'สิงหาคม' },
        { strvalue: '09', strtext: 'กันยายน' },
        { strvalue: '10', strtext: 'ตุลาคม' },
        { strvalue: '11', strtext: 'พฤศจิกายน' },
        { strvalue: '12', strtext: 'ธันวาคม' }]
    },
    confirm_redeem: {
        confirm: "ยืนยัน",
        cancel: "ยกเลิก",

        headline: 'กรุณากดยืนยันเพื่อรับสิทธิ์',
        free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        free_no_timer: 'คุณต้องการแลกรับสิทธิ์',
        free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
        draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
        deal_no_timer: 'คุณต้องการแลกรับสิทธิ์',
        deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        buy: 'ยืนยันการซื้อ',
        buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
        interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
    },
    redeem_button: {
        default: 'รับสิทธิ์',
        none: '',
        soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        soldOutBuy: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
        maxPerPerson: 'ขออภัย คุณได้แลกรับสิทธิ์นี้แล้ว',
        redeemCoolDown: 'ขออภัย คุณได้รับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
        nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
        campaignExpired: 'แคมเปญนี้หมดอายุแล้ว',
        campaignExpiredBuy: 'แคมเปญนี้หมดอายุแล้ว',
        campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
        campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
        notEnoughPoint: 'คะแนนของคุณไม่เพียงพอที่จะแลกรับสิทธิ์',
        notSupport: 'ไม่รองรับแคมเปญประเภทนี้'
    },
    purchase: {
        show_code: 'กดเพื่อดูรหัส',
        code_expired: 'รหัสหมดอายุ',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
        shipped: 'สินค้าได้ถูกจัดส่งเรียบร้อยแล้ว',
        parcel_no: 'พัสดุเลขที่',

        not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
        not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
        draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
        draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
        draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
        draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
    },
    serial: {
        close_btn: 'ปิด',
        show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',

        delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

        draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
        draw_after: 'หลังจากวันที่',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        expire_in: 'หมดเวลาใน ',
        code_expired: 'รหัสหมดอายุ',

        redeem_on: 'รับสิทธิ์เมื่อ {0}'
    },
    register: {
        firstname_th: {
            name: 'ชื่อภาษาไทย (ไม่ต้องมีคำนำหน้า)',
            placeholder: '',
            required: 'กรุณากรอกชื่อ ภาษาไทย',
            too_short: '',
            invalid: '',
        },
        lastname_th: {
            name: 'นามสกุล ภาษาไทย',
            placeholder: '',
            required: 'กรุณากรอกนามสกุล ภาษาไทย',
            too_short: '',
            invalid: '',
        },
        firstname_en: {
            name: 'Firstname English',
            placeholder: '',
            required: 'กรุณากรอกชื่อ ภาษาอังกฤษ',
            too_short: '',
            invalid: '',
        },
        lastname_en: {
            name: 'Lastname English',
            placeholder: '',
            required: 'กรุณากรอกนามสกุล ภาษาอังกฤษ',
            too_short: '',
            invalid: '',
        },
        contact_number: {
            name: 'เบอร์โทรศัพท์ (โดยไม่กรอกเลข 0 นำหน้า)',
            name2: '(โดยไม่กรอกเลข 0 นำหน้า)',
            placeholder: '',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: '',
            invalid: '',
        },
        birthdate: {
            name: 'วันเกิด',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
            age_consent: "คุณต้องมีอายุอย่างน้อย 20 ปีขึ้นไป จึงสามารถเข้าใช้งานได้",
            required_all: 'กรุณากรอก วัน/เดือน/ปี ให้ครบถ้วน',
        },
        country: {
            label: 'สถานที่อยู่อาศัย',
            name: 'ประเทศที่อยู่อาศัย',
            placeholder: '',
            required: 'กรุณากรอกวันเกิด',
            too_short: '',
            invalid: '',
        },
        day: "วัน",
        month: "เดือน",
        year: "ปี",
        email: {
            name: 'อีเมล',
            placeholder: '',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
    },
    shipping: {
        headline: 'ที่อยู่จัดส่ง',

        firstname: {
            name: 'ชื่อ',
            placeholder: 'ชื่อ',
            required: 'กรุณากรอกชื่อ',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'นามสกุล',
            placeholder: 'นามสกุล',
            required: 'กรุณากรอกนามสกุล',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'ที่อยู่',
            placeholder: 'กรุณากรอกที่อยู่',
            required: 'กรุณากรอกที่อยู่',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'เบอร์โทรศัพท์',
            placeholder: 'เบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        nationalid: {
            name: 'เลขประจำตัวประชาชน',
            placeholder: 'เลขประจำตัวประชาชน',
            required: 'กรุณากรอกเลขประจำตัวประชาชน',
            too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
            invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
        },
        email: {
            name: 'อีเมล',
            placeholder: 'อีเมล',
            required: 'กรุณากรอกอีเมล',
            too_short: '',
            invalid: 'อีเมลไม่ถูกต้อง',
        },
        zipcode: {
            name: 'รหัสไปรษณีย์',
            placeholder: 'รหัสไปรษณีย์',
            required: 'กรุณากรอกรหัสไปรษณีย์',
            too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
            invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
        },
        subdistrict: {
            name: 'เขต/ตำบล',
            placeholder: 'กรุณาเลือกเขต/ตำบล',
            required: 'กรุณาเลือกเขต/ตำบล',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'แขวง/อำเภอ',
            placeholder: 'กรุณาเลือกแขวง/อำเภอ',
            required: 'กรุณาเลือกแขวง/อำเภอ',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'จังหวัด',
            placeholder: 'กรุณาเลือกจังหวัด',
            required: 'กรุณาเลือกจังหวัด',
            too_short: '',
            invalid: '',
        },

        save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
        save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

        confirm_btn: 'ยืนยัน',
        cancel_btn: 'ยกเลิก',

        alert_headline: 'ที่อยู่จัดส่ง',
        alert_ok_btn: 'ตกลง',
    },
    main: {
        home_page: "หน้าแรก",
        login: "เข้าสู่ระบบ",
        campaign: "แคมเปญ",
        category: 'หมวดหมู่',
        map: "แผนที่",
        history: 'ประวัติรับสิทธิ์',
        profile: "โปรไฟล์",
        logout: "ออกจากระบบ",
        lang: "ภาษา",
        msgLogout: "ต้องการออกจากระบบ",
        cancel: "ยกเลิก",
    },
    campaign: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
    },
    detail: {
        detail: 'รายละเอียด',
        condition: 'เงื่อนไข',

        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',
        available_date: 'แลกได้วันที่',

        color: {
            name: 'สี',
            placeholder: 'กรุณาเลือกสี',
            required: 'กรุณาเลือกสี',
        },
        size: {
            name: 'ขนาด',
            placeholder: 'กรุณาเลือกขนาด',
            required: 'กรุณาเลือกขนาด',
        },
    },
    history: {
        point: 'คะแนน',
        get_point: 'ได้คะแนน : ',
        use_point: 'ใช้คะแนน : ',

        parcel_number: 'เลขพัสดุ : ',
    },
    otp: {
        headline: 'รหัสยืนยันตัวตน',
        line1: "กรุณากรอกรหัส OTP ตามที่ท่านได้รับจาก SMS <br/> ที่ส่งไปยังเบอร์ที่ท่านได้ให้ข้อมูลไว้ เพื่อยืนยันตัวตน",
        line2: 'รหัส OTP',

        resend_line1: 'เวลาใช้รหัส : ',
        resend_line3: 'รหัสใช้ครั้งเดียวหมดอายุ',
        resend_line2: 'ส่งอีกครั้ง',

        otp_is_empty: 'Please input OTP',
        otp_is_not_correct: 'รหัสใช้ครั้งเดียวไม่ถูกต้อง', //'OTP is not correct',
        otp_already_register: 'This mobile no. has already registered',

        headline_error: 'ลงทะเบียนไม่สำเร็จ',
        msg_error: 'ขออภัย การลงทะเบียนไม่สำเร็จ<br/>กรุณาลองใหม่อีกครั้ง',
        invalid_otp_error: 'คุณกรอกรหัสผิด<br/>กรุณาลองใหม่อีกครั้ง',
        again: 'ลองใหม่อีกครั้ง',
        register_limit: 'คุณทำรายการเกินจำนวนครั้งที่กำหนด กรุณาคลิกเพื่อเริ่มลงทะเบียนใหม่',
        register_time: 'คุณได้ทำการลงทะเบียนเกินเวลาที่กำหนด กรุณาลองใหม่อีกครั้ง',
        time_left1: 'รหัสจะหมดอายุภายใน',
        newregis: 'ลงทะเบียนใหม่',
        otp_expire: 'รหัสหมดอายุ กรุณาลองใหม่อีกครั้ง'

    },
    gateway: {
        text_title: 'ติดตามเรื่องราวล่าสุดจาก CHANEL </br> พร้อมด้วยคอนเทนต์พิเศษต่างๆ </br> ได้ทาง LINE OFFICIAL ACCOUNT </br> เมื่อลงทะเบียนกับเราเรียบร้อยแล้ว',
        smart_phone: 'หากคุณใช้สมาร์ทโฟน </br> โปรดคลิกด้านล่างนี้เพื่อลงทะเบียน',
        computer: 'หากคุณใช้คอมพิวเตอร์ โปรดสแกน </br> QR Code ด้านล่าง ด้วยสมาร์ทโฟนของคุณเพื่อลงทะเบียน',
    },
    maintena: {
        title: "THIS SERVICE IS </br> TEMPORARILY UNAVALABLE",
        text: "We are working to offer you the best </br> experience possible. Please try again later.",
        btn_text: "EXPLORE CHANEL.COM"
    }
};
